import {
    getFormatMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import {
    getLastNameRegExp,
    getNameRegExp
} from '../../../utils/formValidation/validationPatterns';

export const validateReferralDate = (referralDate, errors) => {
    if (!referralDate) {
        return {
            ...errors,
            referralDate: { error: true, message: getReqMessage('Referral date') }
        };
    }
    return errors;
};

export const validateFirstName = (firstName, errors) => {
    if (firstName?.trim().length === 0) {
        return {
            ...errors,
            firstName: { error: true, message: getReqMessage('First name') }
        };
    } else if (!getNameRegExp().test(firstName)) {
        return {
            ...errors,
            firstName: { error: true, message: getFormatMessage('First name') }
        };
    }
    return errors;
};

export const validateMiddleName = (middleName, errors) => {
    if (middleName && !getNameRegExp().test(middleName)) {
        return {
            ...errors,
            middleName: { error: true, message: getFormatMessage('Middle name') }
        };
    }
    return errors;
};

export const validateLastName = (lastName, errors) => {
    if (lastName && !getLastNameRegExp().test(lastName)) {
        return {
            ...errors,
            lastName: { error: true, message: getFormatMessage('Last name') }
        };
    }
    return errors;
};

export const validatePreferredName = (
    preferredName,
    errors
) => {
    if (preferredName && !getNameRegExp().test(preferredName)) {
        return {
            ...errors,
            preferredName: { error: true, message: getFormatMessage('Preferred name') }
        };
    }
    return errors;
};
